import { DownArrowIcon } from 'assets/icons';
import React, { FC, useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';

interface CustomTimePickerProps {
  className?: string;
  id: string;
  startDate: Date;
  onSelect: (value: Date) => void;
  shouldSetMinTime?: boolean;
  minTime?: Date;
  error?: string;
  filterTime?: boolean;
  calendarClassName?: string;
}

const TIME_PICKER_ARROW_ID = 'time-picker-arrow-id';

const CustomTimePicker: FC<CustomTimePickerProps> = ({
  id,
  startDate,
  onSelect,
  shouldSetMinTime = false,
  minTime,
  error = '',
  filterTime = false,
  calendarClassName = 'w-[178px] left-1.5'
}) => {
  const [selectedTime, setSelectedTime] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const datePickerRef = useRef(null);

  useEffect(() => {
    const date = new Date(new Date(startDate));
    const currentDate = new Date();
    currentDate.setMilliseconds(0);
    date.setMilliseconds(0);

    setSelectedTime(date);
  }, [startDate]);

  const handleSelect = value => {
    setSelectedTime(value);
    onSelect(value);
    closeDropdown();
  };

  const filterPassedTime = time => {
    if (filterTime) {
      const currentDate = new Date();
      const date = new Date(time);
      return currentDate.getTime() < date.getTime();
    }
    return true;
  };

  const getMaxTime = () => {
    const date = new Date(startDate).setHours(23, 45, 0, 0);
    return new Date(date);
  };

  const openDropdown = () => {
    if (!isOpen) {
      datePickerRef.current.setOpen(true);
      setIsOpen(true);
    }
  };

  const closeDropdown = () => {
    if (isOpen) {
      datePickerRef.current.setOpen(false);
      setIsOpen(false);
    }
  };

  return (
    <div className="relative">
      <div className="relative h-full w-full rounded bg-secondaryBtn px-5 py-3.5">
        <div className="flex w-full items-center justify-between rounded bg-secondaryBtn">
          <DatePicker
            id={id}
            ref={datePickerRef}
            selected={selectedTime}
            onChange={handleSelect}
            showTimeSelect={true}
            showTimeSelectOnly={true}
            timeIntervals={15}
            timeCaption=""
            dateFormat="hh:mm aa"
            timeFormat="hh:mm aa"
            filterTime={filterPassedTime}
            shouldCloseOnSelect={true}
            open={isOpen}
            onInputClick={openDropdown}
            onClickOutside={closeDropdown}
            calendarClassName={calendarClassName}
            {...(shouldSetMinTime && { minTime: minTime, maxTime: getMaxTime() })}
            customInput={<input className="h-full w-full text-17px font-normal text-primaryText outline-none" />}
          />
          <div id={TIME_PICKER_ARROW_ID} className="cursor-pointer" onClick={openDropdown}>
            <DownArrowIcon />
          </div>
        </div>
      </div>
      {error && <div className="absolute mt-1 text-xs text-error">{error}</div>}
    </div>
  );
};

export default CustomTimePicker;
